import BaseCommand from "@/models/api/commands/BaseCommand";

export class ChangePurchaseNetPriceCommand extends BaseCommand {
  CommandName = "ChangePurchaseNetPrice";
  Command: {
    Amount: number;
    BookingItemTmpId: string;
  };
  constructor(sessionId: string, operationId: string, bookingItemTmpId: string, amount: number) {
    super(sessionId, operationId);
    this.Command = { BookingItemTmpId: bookingItemTmpId, Amount: amount };
  }
}
